<template>
  <v-snackbar
    v-model="notification.show"
    :timeout="notification.time"
    :color="notification.styles.color"
    :top="notification.styles.position === 'top'"
    :bottom="notification.styles.position === 'bottom'"
    :right="notification.styles.alignment === 'right'"
    :left="notification.styles.alignment === 'left'"
    :centered="notification.styles.alignment === 'center'"
    :class="[
      'd-flex',
      'pa-2',
      notification.styles.textColor
    ]"
  >
    {{ notification.message }}
  </v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['notification'])
  }
}
</script>
